import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  type:             PropTypes.string.isRequired,
  actionLabel:      PropTypes.string.isRequired,
  buttonClassName: PropTypes.string,
  onClick:          PropTypes.func.isRequired,
};

const Action = ({ type, actionLabel, buttonClassName, onClick, dataPath }) => {
  const button = () => {
    return (
      <button
        data-testid='action-button'
        data-path={dataPath}
        className={buttonClassName}
        onClick={onClick}
      >
        {actionLabel}
      </button>
    );
  }

  const anchor = () => {
    return (
      <a
        role='button'
        className='_displayBlock _marginBottom--medium _textUnderline'
        data-path={dataPath}
        onClick={onClick}>
      {actionLabel}
      </a>
    );
  }

  const callToAction = () => { 
    switch(type) {
      case 'anchor':
        return anchor();
      case 'button':
        return button();
      default:
        return null;
    }
  };

  return callToAction()
}

Action.propTypes = propTypes;
export default Action;



// WEBPACK FOOTER //
// ./src/features/PrincipalPaydown/components/Hero/Action.js